angular.module("tromanWeb").controller('WageGroupDetailsController', ['stateService', 'tromanServer', 'dialogService', 'wageGroupShared', function (stateService, tromanServer, dialogService, wageGroupShared) {


    let isSaving = false;

    this.canSave = function () {
        return this.wageGroup != null && this.form.$dirty && !isSaving;
    };

    this.save = function save() {
        if (!this.canSave()) return;

        this.form.$commitViewValue();
        this.form.$setSubmitted();

        if (this.form.$invalid) return;

        isSaving = true;
        if (this.wageGroup.Id == null) {
            tromanServer.WageGroups.addEntity(this.wageGroup)
                .finally(() => isSaving = false)
                .then(rsp => {
                    stateService.forceGo('wagegroup.details', { wageGroupId: rsp.result.Id }, { reload: true, location: 'replace' });
                })
                .catch(dialogService.error);
        } else {
            tromanServer.WageGroups.updateEntity(this.wageGroup)
                .finally(() => isSaving = false)
                .then(() => {
                    stateService.forceReload('wagegroup');
                })
                .catch(dialogService.error);
        }
    };

    this.hardRemove = function hardRemove() {
        if (this.wageGroup == null || this.wageGroup.Id == null) return;

        dialogService.confirm(['Radera lönegruppen permanent.', 'Detta kan inte ångras', 'Är du säker?']).then(() => {
            tromanServer.WageGroups.hardRemove(this.wageGroup.Id)
                .then(() => {
                    stateService.forceGo('wagegroups');
                })
                .catch(err => { dialogService.error(err); });
        });
    };

    this.canArchive = function () {
        return this.showArchive && !this.form.$dirty;
    };

    this.archive = function archive() {
        if (!this.canArchive()) return;

        dialogService.confirm(["Arkivera " + this.wageGroup.Name + ".", "Är du säker?"]).then(() => {
            tromanServer.WageGroups.archive(this.wageGroup.Id)
                .then(() => {
                    stateService.reload('wagegroup');
                })
                .catch(err => { dialogService.error(err); });
        });
    };

    this.canActivate = function () {
        return this.showActivate && !this.form.$dirty;
    };

    this.activate = function activate() {
        if (!this.canActivate()) return;

        dialogService.confirm(["Aktivera " + this.wageGroup.Name + ".", "Är du säker?"]).then(() => {
            tromanServer.WageGroups.activate(this.wageGroup.Id)
                .then(() => {
                    stateService.reload('wagegroup');
                })
                .catch(err => { dialogService.error(err); });
        });
    };

    this.$onInit = function $onInit() {
        this.wageGroup = wageGroupShared.wageGroup.clone();
        this.isAdding = !this.wageGroup.Id;
        this.showArchive = !!(this.wageGroup.Id && this.wageGroup.Active);
        this.showActivate = !!(this.wageGroup.Id && !this.wageGroup.Active);
        stateService.guard(() => this.form.$dirty);
    };
}]);

